'use strict';

var angular = require('angular');
var dependencies = ['ngAnimate', 'AVRO.Common.Moment', 'AVRO.Common.FeatureToggle'];
module.exports = angular.module('AVRO.Common.TrueOD', dependencies).directive('rmTrueOd', require('./directives/TrueODDirective')).controller('TrueODController', require('./controllers/TrueODController')).factory('TrueODService', require('./services/TrueODService')).factory('AirlineColorService', require('./services/AirlineColorService'));